import { render } from "./SmPlanIcon.vue?vue&type=template&id=36da0e92&scoped=true"
const script = {}

import "./SmPlanIcon.vue?vue&type=style&index=0&id=36da0e92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da0e92"]])

export default __exports__